import { query } from '@/service/apollo/client'
import { gql } from '@apollo/client'

const getBlog = (tag, limit = 10, offset = 0) => {
  const where = { ...(tag && {tags: { id: tag } }) }
  return query(
    gql`
      query($where: JSON) {
        blogs(where: $where, limit: ${limit}, start: ${offset}) {
          id
          slug
          thumbnail {
            url
          }
          title
          shortDescription
          published_at
          tags {
            id
            name
            nameTHA
          }
        }
      }
    `, {
      where
    }
)
}

const getTag = () => query(
  gql`
    query {
      tags {
        id
        name
        nameTHA
      }
    }
  `
)

const countBlog = (tag) => {
  const where = { ...(tag && {tags: tag }) }
  return query(
    gql`
      query($filter: JSON) {
        blogsCount(where: $filter)
      }
    `,
    {
      filter: where
    }
  )
}


const getBlogBySlug = (slug) => query(
  gql`
    query {
      blogs(where: { slug: "${slug}"}) {
        id
        thumbnail {
          url
        }
        detail
        title
        shortDescription
        published_at
        tags {
          name
          nameTHA
        }
      }
    }
  `
)

export {
  getBlog,
  getBlogBySlug,
  getTag,
  countBlog
}